"use client";

import { SwitchRoiForm as SharedSwitchRoiForm } from "@/components/compare/SwitchRoiForm.client";

export function SwitchRoiForm() {
  return (
    <SharedSwitchRoiForm
      competitorValue="snapcomms"
      competitorLabel="SnapComms"
      formName="switch_roi_snapcomms"
    />
  );
}
